<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-8 px-2 sm:px-3">
    <header>
      <h1 class="font-display text-2xl md:text-3xl font-bold text-gray-900">Mon Wallet</h1>
      <p class="text-gray-500 mt-1">
        @if (showQr()) {
          Votre carte d'identité numérique d'entreprise.
        } @else {
          Votre carte d'identité numérique d'entreprise — cliquez sur un champ pour le copier.
        }
      </p>
    </header>

    <div class="flex items-center gap-3 flex-wrap justify-center">
      <button type="button" (click)="downloadApplePass()"
              [disabled]="appleLoading()"
              class="inline-flex items-center gap-2 rounded-xl bg-black px-3 py-2 text-white hover:bg-secondary hover:text-white cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed">
        <span class="material-symbols-outlined text-[16px]" [class.animate-spin]="appleLoading()">
          {{ appleLoading() ? 'progress_activity' : 'add_card' }}
        </span>
        Ajouter à Apple Wallet
      </button>
      <button type="button" (click)="openGoogleWallet()"
                [disabled]="googleLoading()"
                class="inline-flex items-center gap-2 rounded-xl bg-white border border-gray-300 px-3 py-2 text-gray-800 hover:bg-secondary hover:text-white cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed">
          <span class="material-symbols-outlined text-[16px]" [class.animate-spin]="googleLoading()">
            {{ googleLoading() ? 'progress_activity' : 'add_card' }}
          </span>
          Ajouter à Google Wallet
      </button>
      @if (isAdmin()) {
        <button type="button" (click)="pushWalletUpdate()"
                [disabled]="pushLoading()"
                title="Met à jour le format et les données des passes déjà installés"
                class="inline-flex items-center gap-2 rounded-xl bg-secondary text-white px-3 py-2 hover:bg-secondary-hover cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed">
          <span class="material-symbols-outlined text-[16px]" [class.animate-spin]="pushLoading()">
            {{ pushLoading() ? 'progress_activity' : 'sync' }}
          </span>
          Mettre à jour le Wallet
        </button>
      }
    </div>

    <div class="flex flex-col items-center gap-6">
      @if (showQr()) {
        <div class="w-full max-w-[360px] rounded-2xl border border-gray-200 bg-white p-6 shadow-sm text-center">
          @if (qrLoading()) {
            <div class="flex flex-col items-center justify-center gap-3 py-16">
              @if (qrLabel() === 'Apple Wallet') {
                <span class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-black text-white" aria-hidden="true">
                  <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.365 1.43c0 1.14-.42 2.2-1.18 3.03-.8.88-2.12 1.55-3.24 1.46-.13-1.1.4-2.26 1.14-3.06.8-.88 2.2-1.52 3.28-1.43zM20.5 17.2c-.6 1.34-.88 1.93-1.65 3.11-1.07 1.6-2.58 3.59-4.45 3.61-1.66.02-2.09-1.08-4.35-1.07-2.26.01-2.74 1.1-4.4 1.08-1.87-.03-3.3-1.82-4.37-3.41C-.4 17.1-.9 12.8.9 9.97c1.12-1.78 2.9-2.9 4.62-2.9 1.72 0 2.8 1.12 4.23 1.12 1.38 0 2.22-1.13 4.22-1.13 1.5 0 3.08.82 4.2 2.23-3.7 2.03-3.1 7.3.33 8.91z"/>
                  </svg>
                </span>
              } @else {
                <span class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white border border-gray-200" aria-hidden="true">
                  <svg viewBox="0 0 24 24" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                </span>
              }
              <span class="material-symbols-outlined text-secondary text-5xl animate-spin">progress_activity</span>
              <p class="text-sm text-gray-600">Génération du QR Code…</p>
            </div>
          } @else if (qrDataUrl()) {
            <div class="flex flex-col items-center gap-2 mb-4">
              @if (qrLabel() === 'Apple Wallet') {
                <span class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-black text-white" aria-hidden="true">
                  <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.365 1.43c0 1.14-.42 2.2-1.18 3.03-.8.88-2.12 1.55-3.24 1.46-.13-1.1.4-2.26 1.14-3.06.8-.88 2.2-1.52 3.28-1.43zM20.5 17.2c-.6 1.34-.88 1.93-1.65 3.11-1.07 1.6-2.58 3.59-4.45 3.61-1.66.02-2.09-1.08-4.35-1.07-2.26.01-2.74 1.1-4.4 1.08-1.87-.03-3.3-1.82-4.37-3.41C-.4 17.1-.9 12.8.9 9.97c1.12-1.78 2.9-2.9 4.62-2.9 1.72 0 2.8 1.12 4.23 1.12 1.38 0 2.22-1.13 4.22-1.13 1.5 0 3.08.82 4.2 2.23-3.7 2.03-3.1 7.3.33 8.91z"/>
                  </svg>
                </span>
              } @else {
                <span class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white border border-gray-200" aria-hidden="true">
                  <svg viewBox="0 0 24 24" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                </span>
              }
              <p class="text-sm font-medium text-gray-900">Scanner pour ajouter à {{ qrLabel() }}</p>
              <p class="text-xs text-gray-500">
                Ouvrez l'appareil photo de votre téléphone et flashez ce code.
              </p>
            </div>
            <img [src]="qrDataUrl()" [alt]="'QR Code ' + qrLabel()" class="mx-auto w-[280px] h-[280px] rounded-lg border border-gray-100" />
          }
        </div>
      } @else {
        <!-- Apple Wallet screen: compact pass (~half) + details below -->
        <div class="w-full max-w-[340px]">
          <div class="relative bg-[#1c1c1e] rounded-[2.5rem] p-3 shadow-2xl">
            <div class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-6 bg-[#1c1c1e] rounded-b-2xl z-10"></div>
            <div class="rounded-[2rem] overflow-hidden bg-[#2c2c2e] h-[640px] flex flex-col">

              <!-- Status strip -->
              <div class="shrink-0 pt-8 pb-2 px-4 flex items-center justify-between text-white/50 text-[10px]">
                <span>Wallet</span>
                <span class="material-symbols-outlined text-[14px]">more_horiz</span>
              </div>

              <!-- Scrollable stack: pass face + back info -->
              <div class="flex-1 overflow-y-auto overscroll-contain px-3 pb-4 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">

                <!-- Pass face (short card — gradient only over this strip) -->
                <div
                  class="rounded-2xl overflow-hidden text-white shadow-lg"
                  style="background: linear-gradient(160deg, #37BEA3 0%, #1a5c4f 42%, #123C33 100%);">
                  <div class="px-3.5 pt-3.5 pb-3">

                    <div class="flex items-start justify-between gap-2">
                      <img src="/images/attestio-logo-transp.png" alt="Attestio" class="h-4 mt-0.5 shrink-0 opacity-95" />
                      <button type="button" class="text-right min-w-0 cursor-pointer"
                              (click)="copyField('Entreprise', details().nomEntreprise)">
                        <div class="text-[13px] font-semibold leading-snug break-words">
                          {{ details().nomEntreprise || 'Mon entreprise' }}
                        </div>
                      </button>
                    </div>

                    <button type="button" class="mt-3.5 block w-full text-left cursor-pointer"
                            (click)="copyField('Dirigeant', details().dirigeant)">
                      <div class="text-[9px] uppercase tracking-wider" style="color: #78BEFF;">Dirigeant</div>
                      <div class="mt-0.5 text-[20px] font-semibold leading-tight">
                        {{ details().dirigeant || '—' }}
                      </div>
                    </button>

                    <div class="mt-3 grid grid-cols-2 gap-2">
                      <button type="button" class="text-left min-w-0 cursor-pointer"
                              (click)="copyField('SIREN', details().sirenFormate || details().siren)">
                        <div class="text-[9px] uppercase tracking-wider" style="color: #78BEFF;">SIREN</div>
                        <div class="mt-0.5 text-[12px] font-semibold truncate">
                          {{ details().sirenFormate || details().siren || '—' }}
                        </div>
                      </button>
                      <button type="button" class="text-right min-w-0 cursor-pointer"
                              (click)="copyField('Capital', details().capitalFormate)">
                        <div class="text-[9px] uppercase tracking-wider" style="color: #78BEFF;">Capital</div>
                        <div class="mt-0.5 text-[12px] font-semibold truncate">
                          {{ details().capitalFormate || '—' }}
                        </div>
                      </button>
                    </div>

                    <button type="button" class="mt-2.5 block w-full text-left cursor-pointer"
                            (click)="copyField('Adresse', details().adresseSiege)">
                      <div class="text-[9px] uppercase tracking-wider" style="color: #78BEFF;">Adresse</div>
                      <div class="mt-0.5 text-[11px] font-semibold leading-snug break-words line-clamp-2">
                        {{ details().adresseSiege || '—' }}
                      </div>
                    </button>

                    <div class="mt-2.5 grid grid-cols-3 gap-1.5">
                      <button type="button" class="text-left min-w-0 cursor-pointer"
                              (click)="copyField('SIRET', compte()?.company?.siret)">
                        <div class="text-[8px] uppercase tracking-wider" style="color: #78BEFF;">SIRET</div>
                        <div class="mt-0.5 text-[10px] font-semibold truncate">{{ compte()?.company?.siret || '—' }}</div>
                      </button>
                      <button type="button" class="text-left min-w-0 cursor-pointer"
                              (click)="copyField('APE', details().codeNaf)">
                        <div class="text-[8px] uppercase tracking-wider" style="color: #78BEFF;">APE</div>
                        <div class="mt-0.5 text-[10px] font-semibold truncate">{{ details().codeNaf || '—' }}</div>
                      </button>
                      <button type="button" class="text-left min-w-0 cursor-pointer"
                              (click)="copyField('N° TVA', details().numeroTvaIntracommunautaire)">
                        <div class="text-[8px] uppercase tracking-wider" style="color: #78BEFF;">N° TVA</div>
                        <div class="mt-0.5 text-[10px] font-semibold truncate">{{ details().numeroTvaIntracommunautaire || '—' }}</div>
                      </button>
                    </div>

                    <div class="mt-3.5 flex flex-col items-center gap-1">
                      <div class="rounded-md bg-white p-1.5">
                        <div class="grid grid-cols-5 gap-[1.5px] w-11 h-11">
                          @for (cell of qrPlaceholderCells; track $index) {
                            <div class="rounded-[0.5px]" [class.bg-gray-900]="cell" [class.bg-white]="!cell"></div>
                          }
                        </div>
                      </div>
                      <div class="text-[8px] text-white/75">Scanner pour ouvrir Attestio</div>
                    </div>
                  </div>
                </div>

                <!-- Pass details (backFields) under the card -->
                <div class="mt-3 rounded-2xl overflow-hidden bg-[#3a3a3c] text-white">
                  <div class="px-3.5 py-2.5 border-b border-white/10">
                    <div class="text-[11px] font-semibold text-white/90">Informations</div>
                  </div>

                  <div class="divide-y divide-white/10">
                    @for (row of backRows(); track row.label) {
                      <button type="button"
                              class="w-full px-3.5 py-2.5 text-left hover:bg-white/5 cursor-pointer"
                              (click)="copyField(row.label, row.value)">
                        <div class="text-[10px] text-white/45">{{ row.label }}</div>
                        <div class="mt-0.5 text-[13px] text-white break-words">{{ row.value }}</div>
                      </button>
                    }

                    <div class="px-3.5 py-2.5">
                      <div class="text-[10px] text-white/45">Espace Attestio</div>
                      <div class="mt-0.5 text-[13px] text-[#78BEFF]">Ouvrir dans Attestio</div>
                    </div>
                    <div class="px-3.5 py-2.5">
                      <div class="text-[10px] text-white/45">Mes documents</div>
                      <div class="mt-0.5 text-[13px] text-[#78BEFF]">Voir tous les documents</div>
                    </div>

                    @for (doc of docLinks(); track doc.label) {
                      <div class="px-3.5 py-2.5">
                        <div class="text-[10px] text-white/45">{{ doc.label }}</div>
                        <div class="mt-0.5 text-[13px] text-[#78BEFF]">Télécharger {{ doc.label }}</div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>
